import styled from 'styled-components';

import StageLoading from './component';

import { Z_INDEX } from 'modules/journey/stop-status-log/z-index';

export default styled(StageLoading)`
  border-top: 2px solid var(--grey100);
  border-left: 2px solid var(--grey100);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${Z_INDEX.LOADING};
  background: #fff;
`;
